/* ============
 * Add License Component
 * ============
 *
 * This is the component for creating batch log
 */
import Forms from '../../utils/forms/forms';
import licenseService from '../../services/license';
import licenseTypeService from '../../services/licenseType';
import licensePermitTypeService from '../../services/licensePermitType';
import licenseGroupService from '../../services/licenseGroup';
import licenseTransformer from '../../transformers/license';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      form: new Forms({
        licenseTypeId: {
          value: '',
          type: 'select',
        },
        licensePermitTypeId: {
          value: '',
          type: 'select',
        },
        licenseGroupIds: {
          value: [],
          type: 'checkboxGroup',
        },
        licenseNumber: {
          value: '',
          type: 'text',
        },
        organizationNumber: {
          value: '',
          type: 'text',
        },
        name: {
          value: '',
          type: 'text',
        },
        streetName: {
          value: '',
          type: 'text',
        },
        postalCode: {
          value: '',
          type: 'text',
        },
        city: {
          value: '',
          type: 'text',
        },
        municipality: {
          value: '',
          type: 'text',
        },
        municipalityNumber: {
          value: '',
          type: 'text',
        },
        validFrom: {
          value: '',
          type: 'date',
        },
        validTo: {
          value: '',
          type: 'date',
        },
        licenseFile: {
          value: '',
          type: 'file',
        },
      }),
      loading: false,
    };
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    orgNumber: {
      type: String,
      required: false,
    },
  },
  mounted() {
    this.loading = true;
    Promise.all([
      licenseTypeService.all(),
      licensePermitTypeService.all(),
      licenseGroupService.all(),
    ]).then(() => {
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  },

  computed: {
    ...mapGetters({
      licenseTypes: 'allLicenseTypes',
      licensePermitTypes: 'allLicensePermitTypes',
      licenseGroups: 'allLicenseGroups',
    }),
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * This method will be called when saving the form.
     */
    save() {
      this.form.loading = true;
      const formData = this.form.data();
      const licenseGroupIds = [];
      this.form.licenseGroupIds.forEach((m) => {
        const licenseGroup = this.licenseGroups.find(p => p.name === m);
        licenseGroupIds.push(licenseGroup.id);
      });
      formData.licenseGroupIds = licenseGroupIds;
      formData.ownerOrganizationNumber = this.orgNumber;
      const license = licenseTransformer.send(formData);
      licenseService.store(license)
      .then(() => {
        licenseService.all(this.clientId);
        this.form.loading = false;
        this.closeModal();
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },

  watch: {
    licenseTypes(licenseTypes) {
      this.form.setOptions('licenseTypeId', licenseTypes.map(l => ({ id: l.id, name: l.name })));
    },
    licensePermitTypes(licensePermitTypes) {
      this.form.setOptions('licensePermitTypeId', licensePermitTypes.map(l => ({ id: l.id, name: `${l.name} (${l.code})` })));
    },
    licenseGroups(licenseGroups) {
      this.form.setOptions('licenseGroupIds', licenseGroups.map(l => ({ id: l.id, name: l.name })));
    },
    'form.licenseTypeId': function (value) {
      if (value) {
        this.form.setOptions('licensePermitTypeId', this.licensePermitTypes.filter(l => +l.licenseTypeId === +value).map(l => ({ id: l.id, name: `${l.name} (${l.code})` })));
        this.form.setOptions('licenseGroupIds', this.licenseGroups.filter(l => +l.licenseTypeId === +value).map(l => ({ id: l.id, name: l.name })));
      }
    },
  },

  components: {
    VForm: require('./../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/addLicense/addLicense.js